import { MOBILE_CUTOFF } from "./constants";
import getDeviceStore from "./helpers/getDeviceStore";
import useDeviceStore from "./useDeviceStore";

export { getDeviceStore, MOBILE_CUTOFF };
export default useDeviceStore;
